import axios from "axios";
import { REGISTER_FAIL, REGISTER_SUCCESS, LOGIN_SUCCESS, LOGIN_FAIL,USER_LOADED,AUTH_ERROR , AXIOS_BASE_URL} from "./types";
import { setAlert } from './setAlert';
import setAuthToken from "../utils/setAuthToken";

axios.defaults.baseURL=AXIOS_BASE_URL

           //login //

export const login = (obj) => async dispatch => {
     const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    const body = obj;
    try {
        const res = await axios.post('api/admin/users/login', body, config)
       console.log(res.data);
        dispatch({
            type: LOGIN_SUCCESS,
            payload: res.data
        });
dispatch(setAlert(res.data.message,'success'))
      //  console.log(res.data?.token)
    } catch (err) {
        console.log(err.response.data.error)
      //setAlert(errors,'danger');

        dispatch(setAlert(err.response.data.error,'danger'))
        dispatch({
            type: LOGIN_FAIL
        });

    }
}

// on userloaded //
export const loaduser = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    if (localStorage.token) {
        console.log(localStorage.token);
        setAuthToken(localStorage.token);

    }
    try {
        const res = await axios.get('api/admin/users/login' , config);

       console.log(res);
        dispatch({
            type: USER_LOADED,
            payload: res.data
        })
    } catch (err) {
        console.log(err);
        console.log(err.response.data.error)
       // dispatch(setAlert(err.response.data.error, 'danger '))
        dispatch({
            type: AUTH_ERROR

        })
    }
}

         //register //


export const register = (obj) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    const body = obj;
    try {
        const res = await axios.post('api/admin/users/register', body, config)
        console.log(res);
        dispatch(setAlert(res.data, 'success'))
        dispatch({
            type: REGISTER_SUCCESS,
            payload: res.data
        });

    } catch (err) {
        console.log(err)
        dispatch(setAlert(err.response.data, 'danger'))
        dispatch({
            type: REGISTER_FAIL
        });

    }
}


